import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "EarthSoutheastAsiaFilled"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.4934 6.20375 17.7962 1.50661 12 1.5ZM3.52495 15H4.49995L7.6327 16.95C7.97648 17.1639 8.42795 17.0663 8.6527 16.7295L9.4087 15.5955C9.60667 15.2982 9.56744 14.9025 9.31495 14.6498L7.49995 12.834L8.24995 10.5H12.2422C12.5486 10.5 12.8242 10.3135 12.9382 10.029L14.1247 7.06278C14.2044 6.86379 14.1951 6.64023 14.0992 6.44853L12.3847 3.01953C15.5298 3.1453 18.3791 4.90968 19.8933 7.66912C21.4075 10.4286 21.3652 13.7796 19.7819 16.5H17.2499C16.8357 16.5 16.4999 16.8358 16.4999 17.25V19.7828C14.1881 21.1286 11.3961 21.3721 8.88617 20.4469C6.37621 19.5217 4.41027 17.5243 3.52495 15ZM14.25 16.5H12.75V18H10.5V19.5H12.75V18H14.25V16.5ZM12.75 13.5H14.25V15H12.75V13.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/EarthSoutheastAsiaFilled.vue"]]);
